module.exports = __webpack_public_path__ + "img/im.im1471ac6.svg";